var _polygon, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHappyStudentRafiki(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-46"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.08,
    y: 127.46,
    width: 160.01,
    height: 105.79,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.56,
    y: 133.19,
    width: 149.04,
    height: 94.34,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.29,
    y: 139.58,
    width: 28.27,
    height: 39.22,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.51,
    y: 143.27,
    width: 31.57,
    height: 43.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.44,
    y: 139.58,
    width: 26.14,
    height: 37.58,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.16,
    y: 142.37,
    width: 23.01,
    height: 42.24,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.88,
    y: 192.75,
    width: 50.29,
    height: 30.85,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.18,
    y: 196.79,
    width: 18.83,
    height: 18.83,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.96,
    y: 200.96,
    width: 19.06,
    height: 19.06,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.43,
    y: 125.91,
    width: 125.9,
    height: 255.78,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.69,
    y: 149.61,
    width: 24.53,
    height: 24.53,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.11,
    y: 149.61,
    width: 24.53,
    height: 24.53,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.53,
    y: 149.61,
    width: 24.53,
    height: 24.53,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.69,
    y: 178.14,
    width: 24.53,
    height: 24.53,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.11,
    y: 178.14,
    width: 24.53,
    height: 24.53,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.53,
    y: 178.14,
    width: 24.53,
    height: 24.53,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.29,243.08a4.73,4.73,0,1,1-4.73-4.73A4.72,4.72,0,0,1,236.29,243.08Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.59,
    y: 126.07,
    width: 47.55,
    height: 22.41,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.71,
    y: 154.77,
    width: 38.43,
    height: 13.21,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.03,
    y: 126.07,
    width: 43.11,
    height: 22.41,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.29,
    y: 154.77,
    width: 34.85,
    height: 13.21,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.95,
    cy: 99.97,
    r: 15.14,
    transform: "translate(-24.26 78.01) rotate(-22.5)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.95,
    cy: 99.97,
    r: 11.81,
    transform: "translate(-24.26 78.01) rotate(-22.5)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.16 103.64 179.53 102.86 183.45 99.73 183.45 92.01 184.45 92.01 184.45 100.21 180.16 103.64",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.08,350.11c0-.34,1.16-34.22,6.67-39.58,5.36-5.21,11.51-.19,11.77,0l.55-.66c-.06-.06-7-5.72-12.92,0-5.76,5.6-6.88,38.76-6.93,40.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.61,356.77c0-.41,3.77-40.67-10.94-57.55l-.65.57c14.46,16.59,10.77,56.49,10.73,56.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.15,352.51l.86-.06c0-.46-2.87-45.78,7.91-55.7l-.58-.63C337.25,306.32,340,350.63,340.15,352.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.75,352.48h.86c0-1.25-.35-30.62-8.69-35.4a5.9,5.9,0,0,0-5.4-.52c-5,2.08-7.54,11.06-7.65,11.44l.83.23c0-.09,2.5-9,7.15-10.87a5.08,5.08,0,0,1,4.64.47C338.4,322.37,338.75,352.18,338.75,352.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,352.5l.86-.05c0-.23-1.26-23.2,4.94-31.29,1.5-2,3.13-2.9,4.86-2.78,4.06.29,7.46,6.23,7.5,6.29l.75-.42c-.15-.27-3.67-6.41-8.19-6.73-2-.14-3.91.91-5.6,3.11C340.72,329,341.94,351.55,342,352.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.64,355.63c.17-2.23,4.05-54.68-2.78-63.93l-.7.52c6.65,9,2.66,62.8,2.62,63.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.66,321.87s4.1,1.52,2.88,5.08-14.18,9.44-14.18,9.44-5.43-5-.44-13.07S323.55,319.32,323.66,321.87Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.48,315.08s-4.36-.18-4.61,3.58,9.46,14.17,9.46,14.17,6.92-2.5,5.44-11.89S342.57,312.77,341.48,315.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.18,297.07s-2.91-.31-2.68-2.08,11.32-6.34,17.86,1c0,0-4.19,7.19-10.24,7.28S345.18,297.07,345.18,297.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.76,292.77s2.63,1.27,3.37-.36-6.25-11.36-15.7-8.55c0,0-.25,8.31,4.83,11.59S339.76,292.77,339.76,292.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.54,320.44s-2-1.62.16-2.41,12.8-.57,12.91,10c0,0-12.39,2.06-13.92-2S353.54,320.44,353.54,320.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.27,296.81s2-1.62-.16-2.42-12.8-.56-12.91,10c0,0,12.39,2.06,13.92-1.95S328.27,296.81,328.27,296.81Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.82,305.3s.18-2-1.41-1.2-7.14,6.75-1.39,12.43c0,0,7.74-5.73,6.34-8.72S334.82,305.3,334.82,305.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.33,308.1s-1.2-1.57.56-1.76,9.64,1.91,7.8,9.77c0,0-9.6-.72-10-4S355.33,308.1,355.33,308.1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.89 381.69 355.84 381.69 359.39 345.62 319.34 345.62 322.89 381.69",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.58,
    y: 341.64,
    width: 43.57,
    height: 7.96,
    transform: "translate(678.73 691.24) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-46"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-46",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.32,98.77H220.6a8.85,8.85,0,0,0-8.85,8.85v25a8.85,8.85,0,0,0,8.85,8.85H232l5,7.89,1-7.89h11.37a8.84,8.84,0,0,0,8.84-8.85v-25A8.85,8.85,0,0,0,249.32,98.77Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.32,98.77H220.6a8.85,8.85,0,0,0-8.85,8.85v25a8.85,8.85,0,0,0,8.85,8.85H232l5,7.89,1-7.89h11.37a8.84,8.84,0,0,0,8.84-8.85v-25A8.85,8.85,0,0,0,249.32,98.77Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.96,
    cy: 120.01,
    r: 14.26,
    transform: "translate(-16.04 201.29) rotate(-45)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.46,126.38a1.29,1.29,0,0,1-1-.46l-5.6-6.59a1.31,1.31,0,0,1,2-1.7l4.59,5.42,7.59-8.94a1.31,1.31,0,0,1,2,1.69l-8.59,10.12A1.31,1.31,0,0,1,233.46,126.38Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.93,234.84l-1.91-.09s-3.26,23.59-5.42,25.44-33.85-4.28-35.7-5.62a.42.42,0,0,1-.13-.21c-1.39-3.47,4.11-42.61,6.13-44.43s8.19,0,8.19,0,13.35,3.13,21,5.21a35.83,35.83,0,0,1,5.11,1.62C411.2,217.94,411.93,234.84,411.93,234.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.83,233.06s-3.27,23.59-5.42,25.44c-1.68,1.44-21.14-1.93-30.64-4.14-1.39-3.47,4.11-42.61,6.13-44.43s8.19,0,8.19,0,13.35,3.13,21,5.21C406,216.73,404.83,233.06,404.83,233.06Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.25,171.22l-1.63-6.64,7.42,1.54s1.1,6-2,6.45Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.66 158.13 355.59 161.62 355.04 166.12 347.62 164.58 349.66 158.13",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.37,210.61a32.59,32.59,0,0,1-3.57,1.48c-.88-.33-1.74-.67-2.59-1-.43-.18-.87-.35-1.29-.54-1.56-.64-3.09-1.33-4.61-2.06l-1.81-.88c-.5-.26-1-.51-1.51-.78-1.14-.62-2.28-1.23-3.41-1.9-.78-.45-1.56-.93-2.33-1.43s-1.58-1.07-2.38-1.67l-.47-.35a22.41,22.41,0,0,1-2.86-2.54,13.35,13.35,0,0,1-1.45-1.75,10.5,10.5,0,0,1-.72-1.16c-.06-.12-.13-.25-.19-.39-.15-.34-.29-.69-.38-1a14.65,14.65,0,0,1-.67-4.28,35.25,35.25,0,0,1,.42-5.87c0-.34.1-.69.15-1a69.57,69.57,0,0,1,1.63-7.19q.75-2.66,1.71-5.3l4.92,1.08c-.08,1.62-.18,3.24-.24,4.86-.11,2.44-.19,4.86-.19,7.22v1c0,1.39.09,2.75.24,4,0,.17.05.35.07.52a7.22,7.22,0,0,0,.49,1.8c.05.1,0,0,.06.06s0,.05.14.14.34.35.6.57a28.15,28.15,0,0,0,4.25,2.85l.09,0c1.61.9,3.31,1.79,5.07,2.62l.37.17c2.46,1.18,5,2.33,7.59,3.41,1,.42,2,.84,2.93,1.23,0,0,3.25.89,4.4,3.13C380.76,207.54,377.92,209.38,375.37,210.61Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.37,210.61a32.59,32.59,0,0,1-3.57,1.48c-.88-.33-1.74-.67-2.59-1-.43-.18-.87-.35-1.29-.54-1.56-.64-3.09-1.33-4.61-2.06C368.79,205.9,373.08,208.52,375.37,210.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.76 404.13 333.45 401.84 336.92 386.63 343.24 388.92 339.76 404.13",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.56 412.52 382.86 412.52 380.95 397 387.65 397 389.56 412.52",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,411.74h8.17a.59.59,0,0,1,.57.46l1.39,6a1,1,0,0,1-1,1.19c-2.63-.05-4.55-.2-7.86-.2-2,0-8.18.21-11,.21s-3.2-2.78-2-3c5.15-1.13,9-2.69,10.66-4.18A1.68,1.68,0,0,1,382,411.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.22,400.56l7.17,1.53a.61.61,0,0,1,.47.57l.1,6.1a1,1,0,0,1-1.18,1c-2.58-.6-6.29-1.56-9.54-2.25-3.8-.82-6.16-1.59-10.62-2.54-2.7-.58-2.89-3.46-1.71-3.47,5.37,0,8.62,1,13.62-.74A3,3,0,0,1,333.22,400.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.92 386.63 335.13 394.47 341.45 396.77 343.24 388.93 336.92 386.63",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.66 397 380.95 397 381.94 405 388.64 405 387.66 397",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.28,392.16,344,396s8.35-36.77,12.79-57.16A219.29,219.29,0,0,1,364,315.06c4.06-11.44,8.9-23.76,12.81-33.39,4.13-10.14,7.2-17.3,7.2-17.3l-23.12-4.68s-17.63,50.75-21.6,70.81C335.21,351.36,333.28,392.16,333.28,392.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.28,392.16,344,396s8.35-36.77,12.79-57.16A219.29,219.29,0,0,1,364,315.06c4.06-11.44,8.9-23.76,12.81-33.39,4.13-10.14,7.2-17.3,7.2-17.3l-23.12-4.68s-17.63,50.75-21.6,70.81C335.21,351.36,333.28,392.16,333.28,392.16Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M364,315.06c4.06-11.44,8.9-23.76,12.81-33.39l-1.79-5.53C368.45,282.26,364.32,303.35,364,315.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.4,262.22s-4.12,57.86-4.37,77.53c-.28,21.53,9.79,63.7,9.79,63.7H391.1s-4.91-38.05-3.27-59.38c1.82-23.86,8.26-77.26,8.26-77.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.4,262.22s-4.12,57.86-4.37,77.53c-.28,21.53,9.79,63.7,9.79,63.7H391.1s-4.91-38.05-3.27-59.38c1.82-23.86,8.26-77.26,8.26-77.26Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "377.36 403.72 391.81 403.72 391.77 399.4 376.68 398.53 377.36 403.72",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.85 392.02 344.65 396.46 346.05 392.33 332.05 387.23 331.85 392.02",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.77,412.91a2,2,0,0,1-1.29-.34,1,1,0,0,1-.34-.84.49.49,0,0,1,.27-.45c.73-.38,2.91,1,3.16,1.1a.17.17,0,0,1,.07.16.15.15,0,0,1-.12.13A8,8,0,0,1,379.77,412.91Zm-1-1.38a.4.4,0,0,0-.2,0c-.05,0-.1.06-.1.18a.66.66,0,0,0,.22.58,3.22,3.22,0,0,0,2.38.12A6.38,6.38,0,0,0,378.76,411.53Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.49,412.68l-.08,0c-.7-.38-2.05-1.85-1.92-2.59a.52.52,0,0,1,.5-.42.89.89,0,0,1,.68.2c.78.64,1,2.57,1,2.66a.14.14,0,0,1-.07.14A.11.11,0,0,1,381.49,412.68ZM380.11,410H380c-.2,0-.22.12-.23.16-.08.45.79,1.56,1.48,2.08a3.84,3.84,0,0,0-.81-2.1A.56.56,0,0,0,380.11,410Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.38,401.32h0c-1.1,0-3-.16-3.62-.95a.88.88,0,0,1-.14-.82.48.48,0,0,1,.34-.35c.89-.28,3.26,1.62,3.52,1.84a.15.15,0,0,1,.05.18A.14.14,0,0,1,332.38,401.32Zm-3.28-1.83H329a.17.17,0,0,0-.13.14.57.57,0,0,0,.08.54c.33.45,1.4.74,2.9.81C331,400.27,329.63,399.42,329.1,399.49Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.38,401.32a.11.11,0,0,1-.11,0c-.72-.52-2-2.28-1.73-3,.07-.17.24-.36.67-.31a1.19,1.19,0,0,1,.81.45,4.56,4.56,0,0,1,.5,2.74.14.14,0,0,1-.09.13Zm-1.37-3a.2.2,0,0,0-.17.11c-.16.43.68,1.78,1.39,2.43a3.71,3.71,0,0,0-.46-2.2.81.81,0,0,0-.59-.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.14,210.05q-1.54,3.73-2.83,7.51c-.23.67-.45,1.33-.67,2-.68,2.09-1.31,4.18-1.89,6.25-.2.73-.4,1.46-.59,2.18-.31,1.14-.6,2.27-.88,3.39-.15.63-.3,1.25-.44,1.86-.35,1.48-.67,2.93-1,4.36s-.56,2.72-.81,4-.54,2.79-.77,4.13-.45,2.63-.65,3.89-.43,2.74-.61,4c-.23,1.61-.44,3.12-.62,4.5-.58,4.15-1,7.2-1.31,8.65l-35.15-7.12c0-2.76,0-5.41.12-8,.07-1.71.15-3.38.27-5,.06-1.07.14-2.12.23-3.15.14-1.57.29-3.09.46-4.57.19-1.66.4-3.26.64-4.8.42-2.85.91-5.49,1.43-7.94.64-3,1.32-5.65,2-8.05.87-3,1.76-5.58,2.58-7.69a48.57,48.57,0,0,1,3.58-7.62,69.73,69.73,0,0,1,8.61.06c.6,0,1.22.11,1.84.17a132.93,132.93,0,0,1,15,3c.93.24,1.88.51,2.8.78C405.11,208.34,409.14,210.05,409.14,210.05Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.42,189c-1.87,4.62-4.51,13.24-1.76,17.13a15.1,15.1,0,0,1-12.41,2.26c-4.12-.93-3.77-3.87-2.54-5.28,5.61-.2,6.24-4.21,6-8.13Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.06,191.48,388.74,195a16.74,16.74,0,0,1-.05,2.75c2.1.12,5.35-1.56,6-3.66A7.2,7.2,0,0,0,395.06,191.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.22,172.31c-1.83,2-3.66,7,.33,6.95S390.36,168.88,387.22,172.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.59,183.32c-2.44,6.18-3.56,9.92-7.79,12.09-6.37,3.26-13.2-2.25-12.65-9,.49-6.13,4.41-15.2,11.39-15.63A9.16,9.16,0,0,1,402.59,183.32Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.55,171.43H399l2.18,4.11c.74.11-.73,2.62-.09,2.63,0,0-3,5.46-1.13,9.15,6.72-.54,11.47-5.82,8.42-9.63C410.33,174.35,406.92,171.87,403.55,171.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.31,189.37a6.2,6.2,0,0,1-4.1,2.51c-2.18.32-3-1.71-2.19-3.64.75-1.74,2.78-4,4.87-3.43A2.86,2.86,0,0,1,403.31,189.37Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.43,180.79a18.54,18.54,0,0,1-3.87,3.4,3.2,3.2,0,0,0,2.3,1.23Z",
    style: {
      fill: "#d4827d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.87,180.6a.33.33,0,0,1-.25-.22,2.55,2.55,0,0,0-1.6-1.65.32.32,0,1,1,.16-.62,3.19,3.19,0,0,1,2,2.07.32.32,0,0,1-.19.41A.45.45,0,0,1,394.87,180.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.83,177.08a.26.26,0,0,1-.16-.09.32.32,0,0,1,0-.45,3.13,3.13,0,0,1,2.71-1,.33.33,0,0,1,.26.38.32.32,0,0,1-.37.25,2.43,2.43,0,0,0-2.15.79A.3.3,0,0,1,384.83,177.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.13,186.64a24,24,0,0,1,1.17,3.26l.6-.07c2.74-.34,3.9-1.4,4.36-2.47a3.53,3.53,0,0,0,.24-1.67,3.36,3.36,0,0,0-.2-.94c-1.34,1-3.87,1.55-5.24,1.77C386.49,186.61,386.13,186.64,386.13,186.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.06,186.52l.37.95c2.58-.32,4.35-.9,5.07-1.78a3.36,3.36,0,0,0-.2-.94C391,185.79,388.43,186.3,387.06,186.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.9,189.83c2.74-.34,3.9-1.4,4.36-2.47a8.91,8.91,0,0,0-3,1A3.33,3.33,0,0,0,387.9,189.83Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.15,172.78s-3.92-6.06-13.14-6.44-9.5,5.76-6.38,7.87l.27-.9a7.85,7.85,0,0,0,2.75,2.12v-1.22a15.54,15.54,0,0,0,4.43,2.87v-1.54s2.4,2,7.39,2.56S409.43,176.63,407.15,172.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.51,182.22a.24.24,0,0,1-.23-.16,1,1,0,0,0-.53-.66.68.68,0,0,0-.52,0,.26.26,0,0,1-.34-.09A.25.25,0,0,1,391,181a1.11,1.11,0,0,1,.93-.09,1.47,1.47,0,0,1,.84,1,.26.26,0,0,1-.15.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.83,180.73a.25.25,0,0,1-.23-.16,1,1,0,0,0-.53-.66.69.69,0,0,0-.51.05.26.26,0,0,1-.35-.09.27.27,0,0,1,.09-.34,1.15,1.15,0,0,1,.93-.09,1.47,1.47,0,0,1,.84,1,.26.26,0,0,1-.15.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.25,207.41s-6.6,20.29-1.66,39l-1.27,1.18s-8.19-19.9-1.3-41.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,202.81s-15.3,19.55-18.16,37.73l.28-4.22s-.1-16.22,13.3-33.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.13,244.51l2.59,4.47L402,254.81a38.6,38.6,0,0,1-2.51-9.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.38,262.07l-16.63-7-1.07,14s18.74.35,19,.46S411.38,262.07,411.38,262.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.38,262.07l-16.63-7-1.07,14s18.74.35,19,.46S411.38,262.07,411.38,262.07Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.73 268.25 395.83 256.24 398.65 251.73 409.77 261.39 407.84 268.02 394.73 268.25",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.73 268.25 395.83 256.24 398.65 251.73 409.77 261.39 407.84 268.02 394.73 268.25",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.64 250.42 397.44 265.86 393.68 269.13 415.77 278.35 419.59 274.4 419.75 260.47 397.64 250.42",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.64 250.42 397.44 265.86 393.68 269.13 415.77 278.35 419.59 274.4 419.75 260.47 397.64 250.42",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.53,265.73l-.6,6.8-6.52-3.86s.91-6,4-5.44Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.91 277.98 402.43 272.75 404.41 268.67 410.93 272.53 406.91 277.98",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.64,219.56c-.68,2.09-1.31,4.18-1.89,6.25-.2.73-.4,1.46-.59,2.18-1.4-2.9-.73-7.79-.73-7.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.3,213.09a50,50,0,0,1,5.46,6.51,82.06,82.06,0,0,1,6.54,10.81,48.71,48.71,0,0,1,3.24,7.88,12.85,12.85,0,0,1,.58,3.17c.07,2.26-2,6.11-4.75,10.13-1.55,2.29-3.31,4.64-5,6.79-3.71,4.71-7,8.45-7,8.45l-5-3.5s2.47-4.5,5-9.36c1.35-2.57,2.71-5.25,3.71-7.41a17.73,17.73,0,0,0,1.6-4.15,6.19,6.19,0,0,0-.1-1.32c-.38-2.11-6.57-15.25-15.07-20.89l3-11C407.6,208.61,410.4,210.24,413.3,213.09Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.77,238.47c4.07,2.66-3.9,14-13.13,12.41s-8.13-8.95-6.46-11.67S302.35,232.31,311.77,238.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.77,238.47c4.07,2.66-3.9,14-13.13,12.41s-8.13-8.95-6.46-11.67S302.35,232.31,311.77,238.47Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.57,235.81s10.94,8.06,12.13,15.07-12.46,12.51-22.35,11.34-18.6-18.63-18.6-18.63S290,244,299.57,235.81Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.57,235.81s10.94,8.06,12.13,15.07-12.46,12.51-22.35,11.34-18.6-18.63-18.6-18.63S290,244,299.57,235.81Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,240.47s-.64-9.74,13.79-2c0,0-6.62-4.5-12.84-3.66s-12.7,7.47-19.54,6.82-3.26,7.46-3.26,7.46S291.39,247.92,298,240.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.73,194.22a169.92,169.92,0,0,0,8.16-22.15c.65-2.7.28-5.55,0-8.44-.43-3.63-1.09-7.44-1.77-11.15l4.66-1.69a55.71,55.71,0,0,1,6,17.53,19.75,19.75,0,0,1-.29,7.13,95.78,95.78,0,0,1-7.69,23.08l-9-4.31Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,194.82c4.45-3.11,8.22-11.38,8.22-11.38l9.15,5.61s-4.23,9.53-5.15,15.71C276.7,208.51,265,194.82,265,194.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.7,202.86c2.33,2.1,4.34,3.4,4.57,1.89a29.86,29.86,0,0,1,.74-3.45,16.56,16.56,0,0,0-4.72-3.59A16.66,16.66,0,0,0,272.7,202.86Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.6 383.91 267.18 384.28 270.71 369.2 264.14 368.83 260.6 383.91",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.26,382.78l-5.44-5a.53.53,0,0,0-.69,0l-4.59,3.74a1.05,1.05,0,0,0,0,1.57c1.92,1.72,2.94,2.45,5.33,4.66,1.48,1.35,5.56,5.4,7.6,7.28s4,0,3.31-1c-3-4.32-4.68-7.91-5-10.16A1.73,1.73,0,0,0,267.26,382.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "270.71 369.2 268.89 376.98 262.31 376.61 264.13 368.84 270.71 369.2"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M271,195.45s9.23,11.51,9.69,39.94c-10.3,2.58-21,3.24-26,4.5-2.21-10.67-3.76-17.21-14.24-37.62A77.17,77.17,0,0,1,251,198.08a85.21,85.21,0,0,1,11.78-3A17.76,17.76,0,0,1,271,195.45Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.87,184.53c1.69,3.6,4.18,10.36,2.16,13.55,0,0,2,3.59,9,1.82,7.75-1.94,2.74-4.77,2.74-4.77-4.48.05-5.16-3.11-5.16-6.24Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,198.09a83.89,83.89,0,0,1,11.78-3l.79-.11c1.39,1.54,2.31,4.22,1.07,8.81,0,0-11.38-1.57-15.17-5.25C250,198.41,250.52,198.24,251,198.09Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.45,186.31l5.2,2.57a11.24,11.24,0,0,0,.16,2.19c-1.68.17-4.34-1-4.94-2.7A5.94,5.94,0,0,1,252.45,186.31Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.74,236.08s4.49,50.8,3.78,70.88c-.74,20.88-14.39,68.35-14.39,68.35l-8.91-.13s7.39-46.33,6.89-66.85c-.55-22.38-7-72.52-7-72.52Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.74,236.08s4.49,50.8,3.78,70.88c-.74,20.88-14.39,68.35-14.39,68.35l-8.91-.13s7.39-46.33,6.89-66.85c-.55-22.38-7-72.52-7-72.52Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.44 375.49 270.89 375.64 271.71 372.31 260.01 371.75 260.44 375.49",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,248.54c6.38,13.31.8,37.34-1.65,46.28-1-13.49-2.78-30-4.18-42.1C264.29,245.9,266.08,242.4,269,248.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.1 324.39 206.24 330.62 221.45 327.96 219.32 321.73 204.1 324.39",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,330.84l-.42-7.39a.61.61,0,0,0-.48-.56l-5.94-1.27a.91.91,0,0,0-1.11,1c.18,2.58.41,3.83.59,7.08.11,2,.22,7.73.38,10.49s2.91,3.1,3.1,2c.82-5.07,2.16-8.59,3.53-10.22A1.52,1.52,0,0,0,208,330.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "221.45 327.96 213.61 329.33 211.47 323.1 219.31 321.73 221.45 327.96"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M273.34,236s-8,52.26-13.26,71.89c-5.43,20.41-43.87,21.63-43.87,21.63l-3.8-8.06s22.51-5.65,32.38-19c4.49-22,9-66.73,9-66.73Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.34,236s-8,52.26-13.26,71.89c-5.43,20.41-43.87,21.63-43.87,21.63l-3.8-8.06s22.51-5.65,32.38-19c4.49-22,9-66.73,9-66.73Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.97 320.68 215.26 330.6 218.81 330.69 215.52 319.5 211.97 320.68",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,333.22a2.7,2.7,0,0,0,.49,1.63,1,1,0,0,0,.78.34.46.46,0,0,0,.41-.24c.4-.77-1.1-3.49-1.27-3.8a.18.18,0,0,0-.17-.09.13.13,0,0,0-.12.11A10.82,10.82,0,0,0,207,333.22Zm1.43,1.28a.46.46,0,0,1,0,.28.15.15,0,0,1-.16.09.6.6,0,0,1-.51-.21c-.39-.43-.51-1.51-.35-3A9.13,9.13,0,0,1,208.44,334.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.13,331.2a.17.17,0,0,0,0,.07c.4.81,1.92,2.46,2.66,2.4.18,0,.39-.13.41-.56a1.22,1.22,0,0,0-.32-.88,5,5,0,0,0-2.6-1.17.14.14,0,0,0-.14.05A.1.1,0,0,0,207.13,331.2ZM209.9,333v.09c0,.28-.13.29-.16.29-.45,0-1.63-1.09-2.17-1.92a4.13,4.13,0,0,1,2.09,1A.93.93,0,0,1,209.9,333Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.3,385.31a2.52,2.52,0,0,0,1.45.78.86.86,0,0,0,.72-.37.47.47,0,0,0,.09-.48c-.29-.87-3.13-1.67-3.46-1.75a.15.15,0,0,0-.17.06.17.17,0,0,0,0,.18A11.53,11.53,0,0,0,268.3,385.31Zm1.79-.21a.51.51,0,0,1,.17.24.17.17,0,0,1,0,.19.58.58,0,0,1-.47.25c-.54,0-1.38-.7-2.29-1.86A8.47,8.47,0,0,1,270.09,385.1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,383.75a.05.05,0,0,0,.05,0c.82.28,2.93.28,3.34-.35.1-.15.16-.39-.13-.72a1.15,1.15,0,0,0-.82-.39,4.41,4.41,0,0,0-2.44,1.2.17.17,0,0,0,0,.15A.14.14,0,0,0,267,383.75Zm3-.9a.46.46,0,0,1,.07.07c.19.21.12.31.1.34-.25.38-1.78.49-2.7.3a3.58,3.58,0,0,1,2-.92A.81.81,0,0,1,269.92,382.85Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.48,236.6l-.24,2.32c-.06.19.2.35.51.33l27.45-2c.24,0,.42-.15.41-.29l-.2-2.29c0-.16-.25-.28-.51-.26l-27,2A.43.43,0,0,0,253.48,236.6Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.48,236.6l-.24,2.32c-.06.19.2.35.51.33l27.45-2c.24,0,.42-.15.41-.29l-.2-2.29c0-.16-.25-.28-.51-.26l-27,2A.43.43,0,0,0,253.48,236.6Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.82,239.29l-.72.05c-.15,0-.27-.05-.28-.14l-.23-3c0-.09.1-.17.25-.18l.72,0c.14,0,.27,0,.27.14l.24,3C256.08,239.2,256,239.28,255.82,239.29Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.82,239.29l-.72.05c-.15,0-.27-.05-.28-.14l-.23-3c0-.09.1-.17.25-.18l.72,0c.14,0,.27,0,.27.14l.24,3C256.08,239.2,256,239.28,255.82,239.29Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M277.37,237.7l-.73.06c-.14,0-.26-.06-.27-.14l-.24-3c0-.09.11-.17.25-.18l.73-.05c.14,0,.27.05.27.13l.24,3C277.62,237.61,277.51,237.69,277.37,237.7Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.37,237.7l-.73.06c-.14,0-.26-.06-.27-.14l-.24-3c0-.09.11-.17.25-.18l.73-.05c.14,0,.27.05.27.13l.24,3C277.62,237.61,277.51,237.69,277.37,237.7Z",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.59,238.5l-.72.05c-.14,0-.27-.05-.27-.14l-.24-3c0-.09.11-.17.25-.18l.72-.05c.15,0,.27.05.28.14l.23,3C266.85,238.41,266.74,238.49,266.59,238.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.59,238.5l-.72.05c-.14,0-.27-.05-.27-.14l-.24-3c0-.09.11-.17.25-.18l.72-.05c.15,0,.27.05.28.14l.23,3C266.85,238.41,266.74,238.49,266.59,238.5Z",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.82,239.29l-.72.05c-.15,0-.27-.05-.28-.14l-.23-3c0-.09.1-.17.25-.18l.72,0c.14,0,.27,0,.27.14l.24,3C256.08,239.2,256,239.28,255.82,239.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.82,239.29l-.72.05c-.15,0-.27-.05-.28-.14l-.23-3c0-.09.1-.17.25-.18l.72,0c.14,0,.27,0,.27.14l.24,3C256.08,239.2,256,239.28,255.82,239.29Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M277.37,237.7l-.73.06c-.14,0-.26-.06-.27-.14l-.24-3c0-.09.11-.17.25-.18l.73-.05c.14,0,.27.05.27.13l.24,3C277.62,237.61,277.51,237.69,277.37,237.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.37,237.7l-.73.06c-.14,0-.26-.06-.27-.14l-.24-3c0-.09.11-.17.25-.18l.73-.05c.14,0,.27.05.27.13l.24,3C277.62,237.61,277.51,237.69,277.37,237.7Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.59,238.5l-.72.05c-.14,0-.27-.05-.27-.14l-.24-3c0-.09.11-.17.25-.18l.72-.05c.15,0,.27.05.28.14l.23,3C266.85,238.41,266.74,238.49,266.59,238.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.59,238.5l-.72.05c-.14,0-.27-.05-.27-.14l-.24-3c0-.09.11-.17.25-.18l.72-.05c.15,0,.27.05.28.14l.23,3C266.85,238.41,266.74,238.49,266.59,238.5Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M245.75,165.89c-4.15,2.41-10.86,9.27-3.64,17.1s21.87-.42,19.35-10.07S251.68,162.45,245.75,165.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.13,179c3,5.81,4.14,8.34,8.5,10.08,6.57,2.61,13.05-2.34,11.85-8.93-1.07-5.93-5.79-14.43-12.68-14.24A8.92,8.92,0,0,0,243.13,179Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.29,172.77c2.67,1.15,3.25,7.62,1,10.22C240.64,183,236.33,169.33,244.29,172.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.54,175.58a14.28,14.28,0,0,0,3.1,2.34,2.26,2.26,0,0,1-1.59,1.09Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.92,185.17a4.8,4.8,0,0,0,3.36,1.44c1.67,0,2.07-1.6,1.23-3s-2.52-2.68-4-2A2.15,2.15,0,0,0,243.92,185.17Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.66,176.23a.32.32,0,0,0,.23-.29,3.65,3.65,0,0,1,1.66-2.45.31.31,0,0,0-.34-.52,4.26,4.26,0,0,0-2,2.94.32.32,0,0,0,.3.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.39,170.7a.34.34,0,0,0,.22-.22.32.32,0,0,0-.22-.39,3.11,3.11,0,0,0-2.8.51.31.31,0,1,0,.41.47h0a2.46,2.46,0,0,1,2.22-.38A.33.33,0,0,0,259.39,170.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.88,180.58a20.86,20.86,0,0,0-.44,2.83l-.5,0c-2.28.16-3.39-.52-3.93-1.32a2.93,2.93,0,0,1-.45-1.32,2.66,2.66,0,0,1,0-.8,10.87,10.87,0,0,0,4.53.62C259.58,180.61,259.88,180.58,259.88,180.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.1,180.63l-.15.83c-2.14.14-3.68-.05-4.39-.65a2.66,2.66,0,0,1,0-.8A10.87,10.87,0,0,0,259.1,180.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.94,183.45c-2.28.16-3.39-.52-3.93-1.32a7.53,7.53,0,0,1,2.57.32A2.76,2.76,0,0,1,258.94,183.45Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.43,175.58l.66-.55s-.16.93-.77.9h0a1.32,1.32,0,0,0-1.57.91C252.72,175.22,254,175.45,254.43,175.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.61,173.34l.66-.55s-.16.93-.77.9h0a1.33,1.33,0,0,0-1.57.91C257.9,173,259.17,173.21,259.61,173.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.34,177.48s2.1-4.14.24-7.77a7,7,0,0,1,1.86,4.16,15.44,15.44,0,0,1,2.88-2.83,11,11,0,0,0-1.45-3.87A5.24,5.24,0,0,1,252,170.8a6.3,6.3,0,0,0-.9-3.69,5.76,5.76,0,0,1,2.31,3.07l2.23-.83s-.5-2.06-1.54-2.62a10.67,10.67,0,0,1,2.67,2.1s2.09-.15,2.57.47a6.89,6.89,0,0,0-4.72-3.88,10.61,10.61,0,0,1,5.08,1.79s-2.81-4.65-10.47-2.67S240,172,239.91,174.3,246.34,177.48,246.34,177.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.11,170a12.17,12.17,0,0,0-12-1.16c-7.12,2.9-3.43,18.14,4.75,24.37s12.62,2.4,12.62,2.4-4.42,1.82-8.52-3.11a10.36,10.36,0,0,0,8.52,1.53l-2.35-.59,2.35-.87a7.72,7.72,0,0,1-5.9-1.45s2.75.79,4.54,0c0,0-9.15-.4-11.66-8.83s6.53-7.18,6.53-7.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.65,151.45l-2.92-4.61,6.67.62s1.7,3.87,0,6l-.64-.08A4.28,4.28,0,0,1,274.65,151.45Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.41 141.96 277.02 141.62 278.4 147.46 271.73 146.84 271.41 141.96",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.75,230.18l-29.69,8.29a148.81,148.81,0,0,0-6.28-18.39c-1.39-3.43-2.73-6.47-3.83-9,0-.1-.08-.2-.13-.3-2-4.73-3.2-7.75-2.36-8.48,2-1.73,9.06-4.32,9.06-4.32s8.7,5.08,13.8,2.93c3.41-1.44,1-6,1-6,3.86-3.11,5.54-2.91,7.43-.72a19.22,19.22,0,0,1,2.6,4.42c4.06,9,7.3,25.55,8.18,30.3.06.31.11.58.14.78h0c0,.11,0,.2,0,.27S282.75,230.18,282.75,230.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.75,230.18l-29.69,8.29a148.81,148.81,0,0,0-6.28-18.39c-1.39-3.43-2.73-6.47-3.83-9a.9.9,0,0,0-.09-.33h0L247,211l1.06.06s.47-8.84,2.17-11.16c0,0,8.38,4.08,13.24,2s2.6-6.27,2.6-6.27a18.65,18.65,0,0,1,8.23,3l.05,0c4.52,9.77,7.71,27.75,8.27,31h0c0,.11,0,.2,0,.27S282.75,230.18,282.75,230.18Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.78,220.08c-1.39-3.43-2.73-6.47-3.83-9,0-.1-.08-.2-.13-.3l0,0h0a6.85,6.85,0,0,1,3.91-.89s.12.42.26,1.15A20.13,20.13,0,0,1,246.78,220.08Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,209.52c-4.58,7.25-10.38,13.88-18.26,17.67a5.72,5.72,0,0,1-7.76-2.93c-1.56-3.25-1.88-6.29-2.34-9.55a83.21,83.21,0,0,1-.49-11.69l4.92-.55c1,3.6,2,7.25,3,10.74.71,2.26,1.4,4.9,2.55,6.7.06.07.08.07.05,0a3.47,3.47,0,0,0-4.08-.75c5.54-3.38,10.14-9.42,13.88-14.87l8.54,5.21Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.05,202c-2.64.94-7.26,8.15-7.26,8.15l8.38,9.65s6.22-5.74,5.93-9.38S244.05,200.9,241.05,202Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.67,198.76s39.31,13.14,54.08,39l-1.32,3.87s-7.86-24-54.3-41.9Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.67,198.76s39.31,13.14,54.08,39l-1.32,3.87s-7.86-24-54.3-41.9Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.66 189.97 235.84 197.06 234.97 213.81 214.07 205.63 215.64 190.39 217.66 189.97",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.66 189.97 235.84 197.06 234.97 213.81 214.07 205.63 215.64 190.39 217.66 189.97",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.01 197.75 233.76 212.26 229.44 213.52 228.96 197.43 235.01 197.75",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.01 197.75 233.76 212.26 229.44 213.52 228.96 197.43 235.01 197.75",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.84 197.06 232.97 198.45 231.56 214.11 212.6 206.48 215.64 190.39 217.66 189.97 235.84 197.06",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.35,217.21c-.46-1.26-.9-2.62-1.3-4-1-3.49-2-7.14-3-10.74l-4.92.55a83.21,83.21,0,0,0,.49,11.69,48.05,48.05,0,0,0,1.07,6,16.51,16.51,0,0,0,1.27,3.51,7.39,7.39,0,0,0,.73,1.16,6.19,6.19,0,0,0,1.64,1.54l.34.2.43.21.45.17a5.44,5.44,0,0,0,.54.15,5.36,5.36,0,0,0,2.29,0,5.93,5.93,0,0,0,1-.32l.36-.17.39-.18c.37-.18.72-.37,1.07-.55C231.19,226.46,229.32,216.43,228.35,217.21Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.11,203.83l-.66-7.9,6.26,3.86s-.22,4.64-2.94,5.93Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.44 190.64 226.51 194.16 224.71 199.79 218.45 195.94 221.44 190.64",
    style: {
      fill: "#ffb573"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.81,256s-16.09,6.56-24.14,5.37-10.28,19,0,23.48,22.22,3.36,26.51.56S166.81,256,166.81,256Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.81,256s-16.09,6.56-24.14,5.37-10.28,19,0,23.48,22.22,3.36,26.51.56S166.81,256,166.81,256Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.81,256s13.31,11.7,14.11,15.26-8.84,14.9-13.45,14.11-3-28.17-3-28.17Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.81,256s13.31,11.7,14.11,15.26-8.84,14.9-13.45,14.11-3-28.17-3-28.17Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.4,214.16c7.21-5.41,15-10.58,22.11-16,2-2.58,2.7-5.85,3.56-9.09,1-4.13,1.77-8.52,2.41-12.82l4.68.08a75.39,75.39,0,0,1,0,13.93c-.62,4.95-1.45,10.82-5.28,14.57a246.19,246.19,0,0,1-21.93,17l-5.5-7.7Z",
    style: {
      fill: "#dc897c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,227.31c6.18.25,19.24-15.19,19.24-15.19l-8.68-8.51a64.36,64.36,0,0,0-13.52,9.5C130,219,132.13,227,139,227.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,227.31c6.18.25,19.24-15.19,19.24-15.19l-8.68-8.51a64.36,64.36,0,0,0-13.52,9.5C130,219,132.13,227,139,227.31Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.77,227.28c-1.9-2.08-1.77-5.09,2-9.23a50.91,50.91,0,0,1,12.83-9.55l3.7,3.62S146.19,226.5,139.77,227.28Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.32,181l-1.6-9.1,8.07-.11s2,6.2-2.15,9.6Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.75 165.68 168.79 167.03 168.79 171.82 160.72 171.93 162.75 165.68",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.11,406.35l-8.41.14a.6.6,0,0,0-.58.48l-1.27,6.18a1,1,0,0,0,.81,1.2.9.9,0,0,0,.23,0c2.72-.09,4.69-.28,8.11-.34,2.1,0,8.45.09,11.36,0s3.23-2.92,2-3.16c-5.35-1.08-9.39-2.63-11.12-4.13A1.68,1.68,0,0,0,123.11,406.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,406.35l-8.4.14a.6.6,0,0,0-.59.48l-1.26,6.18a1,1,0,0,0,.8,1.2.9.9,0,0,0,.23,0c2.72-.09,4.7-.28,8.11-.34,2.1,0,8.45.09,11.36,0s3.24-2.92,2-3.16c-5.35-1.08-9.39-2.63-11.12-4.13A1.68,1.68,0,0,0,194,406.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.83,406.78h11.45s14.58-48.06,15.83-60.32,1.71-43,1.71-43v0l0,.06c.5.66,4.82,6.74,9.8,13.81,6.51,9.25,14.15,20.19,15.76,22.87,4.72,7.9,16.28,66.54,16.28,66.54h11.44s-2.88-52.49-8.76-69.79-31.3-55.08-32.4-57.11c-1.41-2.59-4.87-10.81-4.87-10.81l-34.31,4.77s-.56,5.81-.52,10.89c.16,19.06,3.76,44.82,4.34,51.75C119.71,349.65,112.83,406.78,112.83,406.78Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,213.69s10.27,18.31,8.09,55.38l-34.3,4.77c-1-5.23-1.23-31.38-9.76-55.49a90.8,90.8,0,0,1,11.28-3,126.33,126.33,0,0,1,14.58-2A65.18,65.18,0,0,1,141,213.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.12,269.07l-34.31,4.77c-.61-3.27-.94-14.75-3.19-28.8-.6-3.75-1.34-7.69-2.27-11.69a139.5,139.5,0,0,0-4.3-15,88.85,88.85,0,0,1,11.28-3,126.29,126.29,0,0,1,14.59-2,66.87,66.87,0,0,1,10.11.41S151.29,232,149.12,269.07Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.3,198.66c1.93,4.43,4.71,12.7,2.15,16.5,4.85.91,8.33,1.47,12.83,4,.71-3.14,1.55-7.19,1.55-7.19-5.43-.09-6.15-4-6-7.74Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.58,200.94l6.2,3.3a16.53,16.53,0,0,0,.12,2.65c-2,.15-5.21-1.41-5.88-3.43A6.89,6.89,0,0,1,118.58,200.94Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.83,406.78h11.45s14.58-48.06,15.83-60.32,1.71-43,1.71-43v0l0,.06c.5.66,4.82,6.74,9.8,13.81,6.51,9.25,14.15,20.19,15.76,22.87,4.72,7.9,16.28,66.54,16.28,66.54h11.44s-2.88-52.49-8.76-69.79-31.3-55.08-32.4-57.11c-1.41-2.59-4.87-10.81-4.87-10.81l-34.31,4.77s-.56,5.81-.52,10.89c.16,19.06,3.76,44.82,4.34,51.75C119.71,349.65,112.83,406.78,112.83,406.78Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.04 216.27 114.89 212.71 124.12 214.49 128.81 219.86 129.4 213.66 131.13 211.59 134.92 213.22 134.92 217.1 132.22 216.22 129.89 221.64 122.52 218.61 120.88 220.7 112.04 216.27",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.04 216.27 114.89 212.71 124.12 214.49 128.81 219.86 129.4 213.66 131.13 211.59 134.92 213.22 134.92 217.1 132.22 216.22 129.89 221.64 122.52 218.61 120.88 220.7 112.04 216.27",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.89 221.64 130.78 215.16 134.92 217.1 132.22 216.22 129.89 221.64",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.89 221.64 123.06 216.61 120.88 220.7 122.52 218.61 129.89 221.64",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.62,245c-.6-3.75-1.34-7.69-2.27-11.69a7.19,7.19,0,0,1,4.42-2.58S114.71,239.85,111.62,245Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.82,303.48v0l0,.06c.5.66,4.82,6.74,9.8,13.81A19.55,19.55,0,0,0,142,297.92Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.46,180.05c3.44.88,6.79,9.52,3.08,12.17S118,178.4,124.46,180.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.66,192.31c2.48,6,3.62,9.68,7.83,11.89a8.48,8.48,0,0,0,12.44-8.4c-.55-5.93-4.5-14.8-11.42-15.4A8.57,8.57,0,0,0,111.66,192.31Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.24,183.57l-1.38-5.41a7.36,7.36,0,0,1-4.33,1.38c-6.76-.31-10.94,4.77-7.25,7.83-2.81,1.9-.34,5.77,2.21,8.06,3.53,3.18,6.88,4.36,8.66,2.29,1.69-1.26.79-7.78-.28-10.07C112.27,184.22,116.24,183.57,116.24,183.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.38,199.11a7,7,0,0,0,4.4,1.67c2,0,2.16-1.93.84-3.52-1.19-1.43-3.68-3.15-5.36-2.37S109.82,197.8,111.38,199.11Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.67,191.18c.17.5.58.83.91.73s.46-.59.29-1.09-.58-.82-.91-.72S121.5,190.68,121.67,191.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.39,189.46c.17.5.58.82.91.72s.46-.59.29-1.09-.58-.82-.91-.72S127.22,189,127.39,189.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.66,190.25a19.7,19.7,0,0,0,3.87,3.55,3,3,0,0,1-2.26,1.18Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.28,189.89a.26.26,0,0,1-.15,0,.31.31,0,0,1-.19-.4,3,3,0,0,1,2-1.95.31.31,0,0,1,.37.24.32.32,0,0,1-.23.37,2.37,2.37,0,0,0-1.57,1.55A.31.31,0,0,1,119.28,189.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.19,186.77a.35.35,0,0,1-.28-.09,2.62,2.62,0,0,0-2.14-.83.31.31,0,0,1-.36-.25.32.32,0,0,1,.26-.36h0a3.18,3.18,0,0,1,2.68,1,.31.31,0,0,1,0,.44A.29.29,0,0,1,129.19,186.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.27,180.31s3.47-9.39,12.21-8.66a6.72,6.72,0,0,0-2.2,1.28s7.35-1.58,10.32,3.35l-1.53-.65s2.43,4.08.57,7.21l-.59-1.38s-2.57,4.15-7.25,3.65l1.47-1s-7.85.74-10-1A18.25,18.25,0,0,1,110.27,180.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.77,196.57a42.7,42.7,0,0,0-8,.15c.83,1.72,2.23,3.06,5.24,2.79A2.74,2.74,0,0,0,128.77,196.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.49,198.23a5.49,5.49,0,0,1,3.35.6,3.26,3.26,0,0,1-1.84.68,5.39,5.39,0,0,1-3.34-.6A3.23,3.23,0,0,1,124.49,198.23Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.5,196.54a1.22,1.22,0,0,1-.85,1,32.5,32.5,0,0,1-5.24,0,1.68,1.68,0,0,1-1.4-.77A50.23,50.23,0,0,1,128.5,196.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.13,246l-8.23-9.52-5.8,19.36s3.18,7.1,3.3,6.75S122.13,246,122.13,246Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.05 246.19 113.9 238.2 109.83 237.25 108.66 253.92 113.37 257.2 121.05 246.19",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.05 246.19 113.9 238.2 109.83 237.25 108.66 253.92 113.37 257.2 121.05 246.19",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.7 235.42 117.05 244.83 122.13 245.95 114.39 271.65 107.05 272.43 102.41 261.75 109.7 235.42",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.7 235.42 117.05 244.83 122.13 245.95 114.39 271.65 107.05 272.43 102.41 261.75 109.7 235.42",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.77,246.37l-9-8.84-4.26,19.76s3.74,6.82,3.83,6.46S116.77,246.37,116.77,246.37Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.77,246.37l-9-8.84-4.26,19.76s3.74,6.82,3.83,6.46S116.77,246.37,116.77,246.37Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.72 246.7 107.96 239.29 103.83 238.67 103.97 255.38 108.93 258.28 115.72 246.7",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.72 246.7 107.96 239.29 103.83 238.67 103.97 255.38 108.93 258.28 115.72 246.7",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.56 236.85 111.63 245.66 116.77 246.37 111.09 272.61 103.83 273.95 98.36 263.68 103.56 236.85",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.56 236.85 111.63 245.66 116.77 246.37 111.09 272.61 103.83 273.95 98.36 263.68 103.56 236.85",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.91,227c-5.66,5.93-11.94,11.82-16.56,18.58-.19.31-.39.68-.47.83a1.61,1.61,0,0,0,0-.57c0-.19-.14-.22-.11-.13.37.92,2,2.07,3,2.76a75.19,75.19,0,0,0,10.37,5.31L105,258.27a45.79,45.79,0,0,1-12.72-3.38c-5.52-2.32-10.1-7.26-6.49-13.51a67.39,67.39,0,0,1,8.8-12.06c2.81-3.19,5.67-6.2,8.76-9.15l6.59,6.78Z",
    style: {
      fill: "#dc897c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.82,217.68c-9.79-2-21.66,16.52-21.66,16.52L98,242a113.42,113.42,0,0,0,14.32-10.72C118.51,225.56,116.33,219,109.82,217.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.82,217.68c-9.79-2-21.66,16.52-21.66,16.52L98,242a113.42,113.42,0,0,0,14.32-10.72C118.51,225.56,116.33,219,109.82,217.68Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.63,252.82l9.19-1-.45,8.07s-6.32,1.58-9.43-2.82Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.92 254.32 117.14 260.25 112.37 259.92 112.82 251.85 118.92 254.32",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.71,212.58s20.28,19.12,31,45.23l2.06-1.81S154,228.8,137.22,212.16Z",
    style: {
      fill: "#407BFF"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyStudentRafiki);
export default __webpack_public_path__ + "static/media/Happy-student-rafiki.5856077b2cd019a9b9991ca76c7b2767.svg";
export { ForwardRef as ReactComponent };